import { useContext } from 'react';
import ToastContext from 'ui-kit/old/Toast/context';

export default function useToastContext() {
  return useContext(ToastContext);
}
